import React from 'react';
import {stringsTranslate} from "../../../locales/CustomTranslater";
import {appWords} from "../../../config/Constants";


export default function Section3ForCompanies() {


    const initStrings = {
        headingSection2: stringsTranslate(appWords.experience_over_discount),
        subheadingSection2_1:  stringsTranslate(appWords.brand_loyalty_over_redemption),
        subheadingSection2_2: stringsTranslate(appWords.not_for_quick_sales_boost),
        subheadingSection2_3: stringsTranslate(appWords.limited_coupons_urgency_effect),
        playImg2: "/assets/images/ForCompanies/image 1.webp",
        img2Text: stringsTranslate(appWords.check_why_this_works),
    }

    return (
        <section className="section"  id='discounts'>
            <div className="container-fluid">

                <div
                    className="row align-items-center justify-content-center px-2 px-md-5 px-lg-5 section3-for-companies pb-3 mt-5 mt-md-0 mt-lg-0">
                    <div
                        className="col-lg-6 col-md-12 flex-wrap d-flex align-items-center mt-lg-5 mt-md-5 mt-3 pl-lg-5 pl-md-5 pl-3">
                        <h1 className={"heading-section3-for-companies text-knaek-title"}>{initStrings.headingSection2} </h1>
                        <p className={"mt-3 p-1 line-text text-knaek-title subheading-section3-for-companies"}>{initStrings.subheadingSection2_1}</p>
                        <p className={"mt-3 p-1 line-text text-knaek-title subheading-section3-for-companies"}>{initStrings.subheadingSection2_2}</p>
                        <p className={"mt-3 p-1 line-text text-knaek-title subheading-section3-for-companies"}>{initStrings.subheadingSection2_3}</p>

                    </div>

                    <div
                        className="col-lg-6 col-md-12 flex-wrap d-flex align-items-center mt-5 pr-lg-5 pr-md-5 pr-3 text-center">
                        <img src={initStrings.playImg2}
                             className={"radius-15 w-100 cursor-pointer px-1 mt-0 mt-lg-5 mt-md-5"} alt={""}
                             onClick={() => goToYouTube()}/>
                        <div className={'w-100 flex-wrap d-flex text-center justify-content-center'}>
                            <h5 onClick={() => goToYouTube()}
                                className={"pt-3 pb-3 cursor-pointer text-knaek-title img-text-section3-for-companies "}>
                                {initStrings.img2Text}
                            </h5>
                        </div>

                    </div>
                </div>
            </div>
        </section>
    );

    function goToYouTube() {
        if (window.location.href.toString().includes("give-student-discounts")) {
            window.open('https://www.youtube.com/watch?v=viGUvE0J8iQ')

        } else {
            window.open('https://www.youtube.com/watch?v=MsbjSpcfLm8')

        }

    }
}
